var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 20,
    fill: "#EEFFEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.0005 46.7517L44.2925 41.0442C45.4755 40.6193 46.3295 39.4878 46.3295 38.1629V26.9345V22.8528V21.832C46.3295 20.1475 44.9513 18.7698 43.2676 18.7698H22.0181L13.2474 10L10 13.2483L15.7033 18.9512C14.5195 19.3752 13.665 20.5072 13.665 21.832V22.8528V26.9345V38.1624C13.665 39.8475 15.0432 41.2252 16.7278 41.2252H37.9782L46.7535 50L50.0005 46.7517ZM41.7172 38.4688L30.1828 26.9345H43.5736V38.1624C43.5736 38.326 43.4303 38.4684 43.2676 38.4684L41.7172 38.4688ZM43.2676 21.5261C43.4303 21.5261 43.5736 21.6694 43.5736 21.832V22.8528H26.1012L24.7744 21.5261H43.2676ZM19.6054 22.8528H16.4209V21.832C16.4209 21.6694 16.5642 21.5261 16.7278 21.5261H18.2782L19.6054 22.8528ZM16.7278 38.4688C16.5642 38.4688 16.4209 38.3264 16.4209 38.1629V26.9345H23.6871L35.2214 38.4684L16.7278 38.4688Z",
    fill: "#169D00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame1);
export default __webpack_public_path__ + "static/media/frame1.d7bef3a65a2a07b57b7b3fc89d19bfd0.svg";
export { ForwardRef as ReactComponent };